
import Nav from "@/components/Nav";
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'


export default {
name: "Allservices",
components: {
Nav,
Tab,
TabItem
},
data() {
return {
details: "",
tabList: [
{
title: "寄宿家庭",
id: 1
},
{
title: "后期服务",
id: 2
},
{
title: "在线课程",
id: 3
}
],
tabIndex: 1,
actives: 1
};
},
methods: {

changeTab(id) {
this.tabIndex = id;
this.getDetail(id);
},
getDetail(id) {
this.$api.Articledetails(id).then(res => {
this.details = res.data.data;
});
}
},
created() {},
activated() {
if (this.$route.query.id) {
this.tabIndex = this.$route.query.id;
}
this.getDetail(this.tabIndex);
}
};



// WEBPACK FOOTER //
// ./src/pages/Allservices/allservices.vue